import { getStoredAccessToken } from '@/utils/localStorageHelpers';

// Every post-login V1 → V2 redirect decision is sent to web-api, which logs it
// as `v1_migration_redirect_decision` (service:web-api) so support reports can
// be matched to it in Datadog (COR-8192). web-api adds the user id from the
// token; the event itself carries ids and counts only, no names or emails.
export const MIGRATION_DECISION_PATH = '/api/v1/migration-redirect-decisions';

// decision: the result of decideMigrationRedirect. trigger: 'app_load' (a
// logged-in page load), 'login', or 'navigation' (an in-app route change).
export function migrationDecisionEvent(decision, trigger, routePath) {
  return {
    decision: decision.decision,
    trigger: trigger,
    route: routePath || '',
    activeOrgId: decision.activeOrgId,
    targetOrgId: decision.targetOrgId,
    orgCount: decision.orgCount,
    migratedOrgCount: decision.migratedOrgCount,
  };
}

// A beacon outlives the redirect that usually follows it. It must stay a
// CORS-simple request (text/plain, no custom headers), so the token rides in
// the body and web-api moves it into the Authorization header. Never throws:
// losing the event must not block or delay the redirect.
export function sendMigrationDecision(event) {
  try {
    var token = getStoredAccessToken();
    if (!token) return false;
    var url = (process.env.VUE_APP_BASE_API_URL || '') + MIGRATION_DECISION_PATH;
    var body = JSON.stringify(Object.assign({ token: token }, event));
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      return navigator.sendBeacon(url, body);
    }
    if (typeof fetch === 'function') {
      fetch(url, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain' },
        body: body,
      }).catch(function() {});
      return true;
    }
  } catch (e) {
    // Logging is best effort.
  }
  return false;
}
